let turnstileScriptPromise = null;

export default {
  data() {
    return {
      turnstileToken: null,
      isTurnstileLoading: false,
      turnstileWidgetId: null,
    };
  },
  methods: {
    loadTurnstileScript() {
      if (window.turnstile) {
        return Promise.resolve();
      }

      if (turnstileScriptPromise) {
        return turnstileScriptPromise;
      }

      turnstileScriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return turnstileScriptPromise;
    },

    getTurnstileSiteKey() {
      const siteKey = process.env.VUE_APP_TURNSTILE_SITE_KEY;

      if (!siteKey) {
        throw new Error('Missing VUE_APP_TURNSTILE_SITE_KEY');
      }

      return siteKey;
    },

    waitForVisibleTurnstileContainer(container) {
      return new Promise((resolve) => {
        let attempt = 0;

        const check = () => {
          attempt += 1;

          if (
            container &&
            container.offsetParent !== null &&
            container.getBoundingClientRect().width > 0
          ) {
            resolve();
            return;
          }

          if (attempt >= 50) {
            resolve();
            return;
          }

          window.setTimeout(check, 100);
        };

        check();
      });
    },

    async renderTurnstileWidget(container) {
      if (!container) {
        return;
      }

      await this.waitForVisibleTurnstileContainer(container);
      await this.loadTurnstileScript();

      this.turnstileWidgetId = window.turnstile.render(container, {
        sitekey: this.getTurnstileSiteKey(),
        language: 'id',
        action: 'request_new_otp',
        callback: (token) => {
          this.turnstileToken = token;
        },
        'error-callback': () => {
          this.resetTurnstileToken();
        },
        'expired-callback': () => {
          this.resetTurnstileToken();
        },
      });
    },

    async prepareTurnstileToken(container) {
      this.isTurnstileLoading = true;

      try {
        await this.renderTurnstileWidget(container);
      } finally {
        this.isTurnstileLoading = false;
      }
    },

    resetTurnstileToken() {
      this.turnstileToken = null;

      if (window.turnstile && this.turnstileWidgetId !== null) {
        window.turnstile.reset(this.turnstileWidgetId);
      }
    },

    refreshTurnstileToken() {
      this.resetTurnstileToken();
    },

    removeTurnstileWidget() {
      if (window.turnstile && this.turnstileWidgetId !== null) {
        window.turnstile.remove(this.turnstileWidgetId);
      }
    },
  },
};
